import { getCurrentInstance } from '@/util';

export default function useRouter() {
  const instance = getCurrentInstance();
  return {
    router: instance.proxy.$router,
    route: instance.proxy.$route,
  };
}
